import { useQuery, useMutation } from '@tanstack/react-query';
import { statisticsService } from '../services/statisticsService';
import { StatisticsFilters } from '../types/statistics-types';

export function useStatistics() {
  // Query per ottenere le statistiche
  const getStatisticsQuery = (filters: StatisticsFilters = {}) => useQuery({
    queryKey: ['statistics', filters],
    queryFn: () => statisticsService.getStatistics(filters),
    staleTime: 5 * 60 * 1000, // 5 minuti
  });

  // Mutation per esportare il report
  const exportReportMutation = useMutation({
    mutationFn: ({ format, filters }: { format: 'pdf' | 'xlsx'; filters: StatisticsFilters }) => 
      statisticsService.exportStatisticsReport(format, filters),
  });

  return {
    getStatisticsQuery,
    exportReportMutation,
  };
}